/**
 * MSR EVT-04: "Use this CTA for" picker on an account (organization) CTA. Subscription CTAs only -- they are the
 * ones events copy their tracking codes from. Value "" = any activity (stored as NULL).
 */
import React from "react";
import { ctaActivityOptionsFor } from "../../utils/ctaActivityType";

interface Props {
  id: string;
  value: string;
  onChange: (value: string) => void;
  /** The CTA's stored value, so an uncommon one stays selectable. */
  current?: string | null;
}

const CtaActivityTypeSelect: React.FC<Props> = ({
  id,
  value,
  onChange,
  current,
}) => (
  <div>
    <label
      htmlFor={id}
      className="block text-sm font-medium text-gray-700 mb-1"
    >
      Use this CTA for
    </label>
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
    >
      {ctaActivityOptionsFor(current ?? value).map((o) => (
        <option key={o.value || "any"} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
    <p className="mt-1 text-xs text-gray-500">
      When a gun show or range night copies its QR tracking codes from this
      account, only CTAs at the event QR&apos;s voucher amount (normally $20)
      are considered, in this order: the venue&apos;s CTA marked for that
      activity, then this account&apos;s CTA marked for it, then the
      venue&apos;s &quot;Any activity&quot; CTA, then the account&apos;s
      &quot;Any activity&quot; CTA. Newest first when two tie. If the venue has
      no CTA at that amount, this account&apos;s CTA at the amount is used. A
      CTA marked for a different activity is never used.
    </p>
  </div>
);

export default CtaActivityTypeSelect;
